// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash.debounce';
import Slider from '../slider';

export default (element, data) => {
  if (!element.classList.contains('swiper')) return;
  const rotationSpeed = element.getAttribute('data-speed') * 1000;
  const prevEl = element.querySelector('[data-slider-prev]');
  const nextEl = element.querySelector('[data-slider-next]');
  const ARROW_OFFSET = 40; // Constant for arrow position offset

  const updateArrowColors = (slideContent) => {
    const colorClass = slideContent?.classList.contains('text-white') ? '#ffffff' : '#000000';
    nextEl.querySelector('svg').style.fill = colorClass;
    prevEl.querySelector('svg').style.fill = colorClass;
  };

  const setArrowsPosition = (slideContent) => {
    const slideContentWidth = slideContent?.offsetWidth || 0;
    const pos = (element.offsetWidth - slideContentWidth) / 2;
    const arrowPosition = pos - ARROW_OFFSET <= ARROW_OFFSET ? '40px' : `${pos}px`;

    prevEl.style.left = arrowPosition;
    nextEl.style.right = arrowPosition;
  };

  const handleResize = () => {
    const isMobile = data.layout.bps.below.md.matches;
    const slideContent = element.querySelector('.swiper-slide-active')?.querySelector('[data-content]');
    if (isMobile) {
      prevEl.style.left = '0px';
      nextEl.style.right = '0px';
    } else {
      setArrowsPosition(slideContent);
    }
  };

  const init = () => {
    // eslint-disable-next-line no-unused-vars
    const slider = new Slider({
      el: element,
      options: {
        slidesPerView: 1,
        keyboard: true,
        navigation: { nextEl, prevEl },
        loop: true,
        effect: 'fade',
        speed: 500,
        autoHeight: true,
        autoplay:
          rotationSpeed > 0
            ? {
                delay: rotationSpeed,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,
        on: {
          slideChange: (swiper) => {
            const isMobile = data.layout.bps.below.md.matches;
            const slideContent = swiper.slides[swiper.activeIndex]?.querySelector('[data-content]');
            updateArrowColors(slideContent);
            if (!isMobile) {
              setArrowsPosition(slideContent);
            } else {
              prevEl.style.left = '0px';
              nextEl.style.right = '0px';
            }
          },
        },
      },
    });

    const debouncedResizeHandler = debounce(handleResize, 500);
    window.addEventListener('resize', debouncedResizeHandler);
    handleResize();
  };

  init();
};
